import { apiClient, type CreateSiteDto } from '@/libs/api'

export type CreateSiteRequest = {
  tenantKey: string
  dto: CreateSiteDto
}

export const createSite = async ({ tenantKey, dto }: CreateSiteRequest) => {
  const { data, errors } = await apiClient
    ._tenant(tenantKey)
    .sites.$post({ body: dto })
  return { data, errors }
}
